import MotorTable from './motor-table';

export default MotorTable;
